import React from "react";
import { useState, useEffect } from "react";
import "./Men.css";
import { Link } from "react-router-dom";

function Men() {
  const menData = JSON.parse(localStorage.getItem("list"))[0];
  const menBrands = menData.children.slice(0, 100);

  const [search, setSearch] = useState("");

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    console.log(menData);
    console.log(menBrands);
  }, []);

  return (
    <div className="container men-brands-parent">
      <div className="search text-end">
        <input
          className="search-box"
          type="text"
          placeholder="Search"
          onChange={handleChange}
        />
        <i className="fas fa-search"></i>
      </div>
      <h3 className="text-center">Men's Brands</h3>
      <div className="row women-brands">
        {menBrands
          .filter((brand) => {
            if (
              brand.content.title.toLowerCase().includes(search.toLowerCase())
            ) {
              return brand;
            } else {
              return null;
            }
          })
          .map((brand) => (
            <Link
              key={brand.link.categoryId}
              className="col-lg-2 col-sm-3 col-3 men-categ"
              to={`/products/${brand.link.categoryId}`}
            >
              <div>
                <h4>{brand.content.title}</h4>
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
}

export default Men;
